"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const ChangeCase = tslib_1.__importStar(require("change-case"));
exports.OsmosysChangeCase = ({ children, type = 'sentenceCase', }) => {
    const casedChildren = react_1.useMemo(() => {
        if (!ChangeCase[type]) {
            throw new Error(`${type} is not found`);
        }
        return ChangeCase[type](children);
        // switch (type) {
        //   case 'sentenceCase':
        //     return sentenceCase(children);
        //   default:
        //     return '';
        // }
    }, [children, type]);
    return react_1.default.createElement(react_1.default.Fragment, null, casedChildren);
};
//# sourceMappingURL=OsmosysChangeCase.js.map